import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { searchStreamsPaginated } from "api/streams";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
export const KEY_PREFIX = ["streams", "overview"];
export const keyFn = (searchParams) => [...KEY_PREFIX, searchParams];
export const fetchStreams = (searchParams) => searchStreamsPaginated(searchParams.page, searchParams.pageSize, searchParams.query, {
  sort: searchParams == null ? void 0 : searchParams.sort.attributeId,
  order: searchParams == null ? void 0 : searchParams.sort.direction,
  filters: FiltersForQueryParams(searchParams.filters)
});
const useStreams = (searchParams, { enabled } = { enabled: true }) => {
  const { data, refetch, isInitialLoading } = useQuery({
    queryKey: keyFn(searchParams),
    queryFn: () => defaultOnError(
      fetchStreams(searchParams),
      i18n.t("stream_hooks.load_streams_failed", { ns: "streams" }),
      i18n.t("stream_hooks.load_streams_failed_title", { ns: "streams" })
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isInitialLoading
  };
};
export default useStreams;
